import update from 'immutability-helper';
import isNil from '~/_base/functions/isNil';
import {
  INITIALISED,
  SET_CURRENT_PROJECT,
  SET_GETTING_MAP_DATA,
  SET_MAP_DATA,
  SET_GETTING_EVENT_ACTIVITY_DATA,
  SET_EVENT_ACTIVITY_DATA,
  SET_GETTING_FEED_DATA,
  SET_FEED_DATA,
  FILTER_FEATURES,
  SELECT_FEATURE,
  CLEAR_FEATURE_SELECTION,
  SET_FILTERS,
  CLEAR_CHART_UPDATED,
} from '../actions/actions.types';
import setMapData from './functions/setMapData';
import setGettingMapData from './functions/setGettingMapData';
import setEventActivityData from './functions/setEventActivityData';
import setGettingEventActivityData from './functions/setGettingEventActivityData';
import setFeedData from './functions/setFeedData';
import setGettingFeedData from './functions/setGettingFeedData';
import setProject from './functions/setProject';
import filterFeatures from './functions/filterFeatures';
import selectFeature from './functions/selectFeature';
import clearFeatureSelection from './functions/clearFeatureSelection';
import setFilters from './functions/setFilters';
import clearChartUpdated from './functions/clearChartUpdated';

const initialState = {
  initialised: false,
  mapData: [],
  feedData: [],
  project: null,
  eventActivity: [],
  eventStart: null,
  eventEnd: null,
  boundingRectangle: {},
  gettingFeed: true,
  gettingMap: true,
  gettingChart: true,
  filters: {
    startTime: null,
    endTime: null,
    templates: null,
    users: null,
    set: false,
  },
  renderChart: false,
};

export default function Timetravel(state = initialState, action) {
  switch (action.type) {
    case INITIALISED:
      // console.log('INITIALISED...', action)
      return update(state, {
        initialised: {
          $set: true,
        },
      });
    case SET_CURRENT_PROJECT:
      // console.log('SET_CURRENT_PROJECT..', action)
      return setProject(state, action);
    case SET_GETTING_MAP_DATA:
      // console.log('SET_GETTING_Map_DATA...', action)
      return setGettingMapData(state, action);
    case SET_MAP_DATA: // map data
      //  console.log('SET_MAP_DATA...', action)
      return setMapData(state, action);
    case SET_GETTING_EVENT_ACTIVITY_DATA:
      // console.log('SET_EVENT_ACTIVITY_DATA...', action)
      return setGettingEventActivityData(state, action);
    case SET_EVENT_ACTIVITY_DATA:
      // console.log('SET_FEED_DATA...', action)
      return setEventActivityData(state, action);
    case SET_GETTING_FEED_DATA:
      // console.log('SET_GETTING_FEED_DATA...', action)
      return setGettingFeedData(state, action);
    case SET_FEED_DATA:
      // console.log('SET_FEATURES...', action)
      return setFeedData(state, action);
    case FILTER_FEATURES:
      // console.log('FILTER_FEATURES...', action)
      return filterFeatures(state, action);
    case SELECT_FEATURE:
      // console.log('SELECT_FEATURE...', action)
      return selectFeature(state, action);
    case CLEAR_FEATURE_SELECTION:
      // console.log('CLEAR_FEATURE_SELECTION...')
      return clearFeatureSelection(state, action);
    case SET_FILTERS:
      // console.log('SET_FILTERS...', action)
      return setFilters(state, action);
    case CLEAR_CHART_UPDATED:
      return clearChartUpdated(state, actions);

    default:
      return state;
  }
}
